import { PropsWithChildren } from 'react';

import { IdempotencyProvider } from '@betterment/js-runtime';

import { featureRegistry } from '../graphql/featureRegistry';

type Props = {
  featureName: string;
};

export const IdempotencyProviderWithFeatureRegistry: React.FC<PropsWithChildren<Props>> = ({
  children,
  featureName,
}) => {
  return (
    <IdempotencyProvider featureName={featureName} featureRegistry={featureRegistry}>
      {children}
    </IdempotencyProvider>
  );
};
